import { ModalProps } from '@/types/shared'
import { Dialog } from 'vnetwork-ui'
import { useTranslation } from 'react-i18next'
import LeadStatusLegend from '@/modules/Marketing/components/List/LeadFilters/LeadStatusLegend'

const LeadStatusLegendModal: React.FC<ModalProps> = ({ onClose, open }) => {
    const { t } = useTranslation('marketing')

    return (
        <Dialog
            onClose={onClose}
            open={open}
            title={t('lead_flow.legend_title')}
            maxWidth="sm"
        >
            <LeadStatusLegend className="grid grid-cols-1 sm:grid-cols-1" />
        </Dialog>
    )
}

export default LeadStatusLegendModal
